import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const FiltrosBusqueda = (props) => {
  const {
    provinciasDeBarraOrdenar,
    provinciaElegidaDeBarraOrdenar,
    setProvinciaElegidaDeBarraOrdenar,
    puntoDeEmbarqueDeBarraOrdenar,
    onSelectorEmbarqueChange,
    onLimpiarFiltrosButton,
    onProvinciaFiltrosChange,
  } = props;

  return (
    <div className="filtrosEnResultados">
      <div className="divOrdenar">Busca tu zona más cercana: </div>
      <div className="tags">
        <div className="dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            id="dropdownOrigen"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {provinciaElegidaDeBarraOrdenar.denominacion}
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownOrdenarPor">
            {provinciasDeBarraOrdenar.map((prov) => (
              <Link
                key={prov.codigo}
                className="dropdown-item"
                to={"#"}
                onClick={() => onProvinciaFiltrosChange(prov)}
              >
                {prov.denominacion}
              </Link>
            ))}
          </div>
        </div>
        {provinciaElegidaDeBarraOrdenar.puntosDeEmbarque.length > 0 && (
          <div className="dropdown">
            <button
              className="btn dropdown-toggle"
              type="button"
              id="dropdownParada"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {puntoDeEmbarqueDeBarraOrdenar.denominacion}
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownOrdenarPor">
              {provinciaElegidaDeBarraOrdenar.puntosDeEmbarque.map((e) => (
                <Link
                  key={e.idPuntoDeEmbarque}
                  className="dropdown-item"
                  to={"#"}
                  onClick={() => onSelectorEmbarqueChange(e.idPuntoDeEmbarque)}
                >
                  {e.denominacion}
                </Link>
              ))}
            </div>
          </div>
        )}
        {puntoDeEmbarqueDeBarraOrdenar.idPuntoDeEmbarque > 0 && (
          <button
            className="btn"
            type="button"
            id="dropdownParada"
            onClick={onLimpiarFiltrosButton}
          >
            X
          </button>
        )}
      </div>
    </div>
  );
};

export default FiltrosBusqueda;



// WEBPACK FOOTER //
// ./src/components/Resultados/filtrosBusqueda.js